const ITEMS = ["Tonifier", "Faire circuler", "Respirer", "Se relaxer", "Se recentrer", "S'évader"];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="vf-marquee" data-testid="editorial-marquee">
      <div className="vf-marquee-track">
        {[0, 1].map((half) => (
          <div className="vf-marquee-half" key={half} aria-hidden={half === 1}>
            {row.map((item, i) => <span key={i}>{item}<i>✦</i></span>)}
          </div>
        ))}
      </div>
    </div>
  );
}
